// After a deploy, lazily loaded chunks from the previous build 404. Production reloads once to
// pick up the new build; this mirrors src/shared/utils/chunk-load-error.ts of the old client.
const RELOAD_KEY = 'mydent:chunk-reload-attempted';

const PATTERNS = [
  'failed to fetch dynamically imported module',
  'importing a module script failed',
  'error loading dynamically imported module',
  'chunkloaderror',
  'loading chunk',
];

function messageOf(error: unknown): string {
  if (error instanceof Error) return `${error.name} ${error.message}`.toLowerCase();
  if (typeof error === 'string') return error.toLowerCase();
  if (error && typeof error === 'object' && 'message' in error) {
    return String(error.message).toLowerCase();
  }
  return '';
}

export const isChunkLoadError = (error: unknown) => {
  const message = messageOf(error);
  return PATTERNS.some((p) => message.includes(p));
};

/** Reloads once; returns false if a reload was already attempted (show the error instead). */
export function recoverFromChunkLoadError(): boolean {
  try {
    if (sessionStorage.getItem(RELOAD_KEY) === 'true') {
      sessionStorage.removeItem(RELOAD_KEY);
      return false;
    }
    sessionStorage.setItem(RELOAD_KEY, 'true');
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}

export function clearChunkReloadState() {
  try {
    sessionStorage.removeItem(RELOAD_KEY);
  } catch {
    // Ignore.
  }
}
